

let loc = window.location.pathname;
let initai_state=1
if(loc.includes("dashboard")){
  initai_state=2
}



const MNavChange=(state=initai_state, action)=>{
  switch (action.type) {
    case "home":
      return 1;
    case "dashboard":
      return 2;
    default:
      return state;
  }
}

export default MNavChange; 